// extracted by mini-css-extract-plugin
export default {"container":"NavTab_container__bkJIQ","active":"NavTab_active__zq8Fn","highlight_line":"NavTab_highlight_line__3rH2i"};